<template>
    <div class="__l">
        <h1 class="title">Copify Jobs</h1>

        <div class="actions right text-right">
            <button class="btn-primary" type="button" @click="navigateToProfessionalWriting">Return to Professional
                Writing
            </button>
        </div>

        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">Id</div>
                <div class="results-head" data-width="60%">Title</div>
                <div class="results-head" data-width="20%">Date</div>
                <div class="results-head" data-width="10%">Status</div>
            </div>
            <template v-if="results">
                <div class="results-row" v-for="(result, index) in results" :key="index" @click="handleSelect(result)">
                    <div class="results-cell" data-width="10%">{{ result.id }}</div>
                    <div class="results-cell" data-width="60%">{{ getTitleForJob(result) }}</div>
                    <div class="results-cell" data-width="20%">{{ formatDateShort(result.created) }}</div>
                    <div class="results-cell status" data-width="10%"><span
                        :class="buildCssClass(getStatusForJob(result))">{{ getStatusForJob(result) }}</span></div>
                </div>
            </template>
            <div class="results-row" v-if="!results">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>

        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
export default {
    name: 'ProfessionalWritingCopify',
    data() {
        return {
            search: null,
            results: {},
            statusList: [],
            showAll: 0,
        }
    },
    components: {
        //
    },
    mounted() {
        this.loadData()
        this.setMetaTitle('List Copify Jobs | JournoLink Control')
    },
    methods: {
        getStatuses() {
            return axios.get(route('professionalWriting.copify.statuses'))
        },
        getJobs() {
            return axios.get(route('professionalWriting.copify.jobs'))
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData(page = 1) {
            axios.all([this.getJobs(), this.getStatuses()])
                .then(axios.spread((responseWriting, responseStatus) => {
                    this.results = responseWriting.data
                    this.statusList = responseStatus.data
                }))
                .catch(e => {
                    this.$bus.$emit('alert.danger', 'There was an error retrieving professional writing requests')
                })
        },
        /**
         * Handle the selection of a row
         *
         * @return {void}
         */
        handleSelect(result) {
            this.$router.push({
                name: 'professionalWriting.copify.job',
                params: {jobId: result.id}
            })
        },
        /**
         * Prepare and return the display title for the job
         *
         * @param  {Object} job
         * @return {String}
         */
        getTitleForJob(job) {
            if (job.title !== null) {
                return job.title
            }

            return job.name + ' (' + job.brief.substring(0, 70) + '...)'
        },
        /**
         * create some css classes for each status
         * @param  {string} status
         * @return {string} css friendly status
         */
        buildCssClass(status) {
            return status.toLowerCase().replace(' ', '-')
        },
        /**
         * Retrieve the status text for the given job
         *
         * @param job
         * @return {*|string}
         */
        getStatusForJob(job) {
            let status = this.statusList.find(item => parseInt(item.id) === parseInt(job.job_status_id))

            return status['name'] || 'Unknown'
        },
        /**
         * Navigate back to Professional Writing list
         *
         * @return {void}
         */
        navigateToProfessionalWriting() {
            this.$router.push({name: 'professionalWriting.list'})
        },
    },
}
</script>
<style lang="less">
.status {
    span {
        padding: 5px;
        border-radius: 3px;
        color: white;
    }

    .open,
    .in-progress,
    .rewrite-requested,
    .requires-edits,
    .paused,
    .scheduled {
        background: #2980b9;
    }

    .approved,
    .completed,
    .pending-accept {
        background: #2c3e50;
    }
}
</style>
